<template>
  <div class="flex gap2">
    <div v-for="(option, optionIndex) in options" :key="optionIndex" class="flex items-center">
      <input
        class="ml0"
        :id="`radio-${id}-${optionIndex}`"
        :checked="value === option.value"
        type="radio"
        :name="id"
        :disabled="disabled"
        :value="option.value"
        @change="$emit('update:value', $event.target.value)"
      />
      <label 
        :for="disabled ? '' : `radio-${id}-${optionIndex}`" 
        :class="['h6n', { 'pointer': !disabled, 'opacity-50': disabled }]" 
        style="margin-top: 0.2rem"
      >
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  value: {
    type: [String, Number, null],
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
  }
});

const emit = defineEmits(['update:value']);
</script>